import { useMemo } from 'react';

import { Option as AccessOption } from '@/react/portainer/access-control/AccessManagement/PorAccessManagementUsersSelector';

import type { Option as PortainerOption } from '@@/form-components/PortainerSelect';

import { registry } from './registry';
import { createAccessColumn } from './access';
import type { AccessRow } from './helper';

interface UseColumnsProps {
  userTeamOptions: PortainerOption<AccessOption>[];
  users: AccessOption[];
  teams: AccessOption[];
  handleAccessChange: (
    item: AccessRow,
    selection: readonly AccessOption[]
  ) => void;
}

export function useColumns({
  userTeamOptions,
  users,
  teams,
  handleAccessChange,
}: UseColumnsProps) {
  return useMemo(
    () => [
      registry,
      createAccessColumn({
        userTeamOptions,
        users,
        teams,
        handleAccessChange,
      }),
    ],
    [userTeamOptions, users, teams, handleAccessChange]
  );
}
